export default () => {
    return [
        {
            path: '/riepilogos',
            name: 'riepilogos',
            component: () => import('./views/riepilogos.vue'),
        },
    ];
};
